import React, {useEffect, useState} from 'react';
import {
    Box,
    Button,
    AppBar,
    Toolbar,
    Avatar,
    Typography,
    IconButton,
    Switch,
    CircularProgress,
    Pagination,
    Modal,
    TextField,
    FormControl,
    InputLabel, Select, MenuItem, LinearProgress
} from '@mui/material';
import {Add} from '@mui/icons-material';
import HeaderAvatar from "../components/HeaderAvatar";
import {
    // addCompanyMember, addScaenario, fetchProject, fetchScenario,
    getScenarios,
    addScaenario,
    fetchScenario,
    addPresentation,
    fetchProducts,
    getVisits,
    addProject,
    fetchProject,
    uploadProjectVideo, fetchPresentation
} from '../services/api';
// import {usePermissions} from "../components/PermissionsContext";
import {Project, Scenario, Visit} from "../services/types";
import Icon from "../components/Icon";
import {useNavigate, useParams, useSearchParams} from "react-router-dom";

import {
    fetchProjects
} from '../services/api';
import ScenarioEditor from "../components/ScenarioEditor";
import ProjectEditor from "../components/ProjectEditor";

const Projects: React.FC = () => {
    const [loading, setLoading] = useState(true);
    const [projects, setProjects] = useState<Project[]>([]);
    const [page, setPage] = useState(1);
    const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const [createName, setCreateName] = useState('');
    const [createScenarioId, setCreateScenarioId] = useState<number | string | null>(null);
    const [createVisitId, setCreateVisitId] = useState<number | string | null>(null);
    const [scenarios, setScenarios] = useState<Scenario[]>([]);
    const [visits, setVisits] = useState<Visit[]>([]);
    const [currentProject, setCurrentProject] = useState<Project | null>(null);
    const [isUploadModalOpen, setIsUploadModalOpen] = useState(false);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [progressText, setProgressText] = useState<string>('Пожалуйста, дождитесь завершения загрузки');


    const fetchScenariosData = async () => {
        try {
            const data = await getScenarios(1, 1000);
            setScenarios(data.items);
        } catch (error) {
            console.error('Error fetching products:', error);
        } finally {
        }
    };

    const fetchVisitsData = async (scenarioId: any) => {
        try {
            const data = await getVisits(scenarioId);
            setVisits(data.items);
        } catch (error) {
            console.error('Error fetching products:', error);
        } finally {
        }
    };

    useEffect(() => {
        loadProjects();
        fetchScenariosData();

    }, [page]);

    const navigate = useNavigate();
    const { id } = useParams();

    useEffect(() => {
        if (id) {
            fetchProject(Number(id)).then(setCurrentProject);
        }else{
            setCurrentProject(null)
        }
    }, [id]);

    const loadProjects = async () => {
        setLoading(true)
        try {
            const data = await fetchProjects(page, 100, null, null, null, null, null);
            setProjects(data.items);
            setLoading(false)
        } catch (error) {
            console.error('Error fetching team members:', error);
            setError('Failed to load team members');
            setLoading(false)
        }
    };

    const handleProjectClick = (project: Project) => {
        setCurrentProject(project);
        navigate(`/projects/${project.id}`);
    };
    const handleCreate = async () => {
        try {

            const date = new Date();
            const isoDate = date.toISOString();
            const addData = {
                title: createName,
                description: "",
                visitId: createVisitId,
                status: 'ACTIVE',
                startDate: isoDate,
                endDate: isoDate,
                multipleSessionWriteCount: 0,
                multipleSessionAvailableCount: 0,
                subtitles: ''
            }
            await addProject(addData);
            setIsCreateModalOpen(false);
            setCreateName('');
            setCreateVisitId(null);
            loadProjects();
        } catch (error) {
            console.error('Error inviting team member:', error);
            setError('Failed to send invitation');
        }
    };
    const updateProjectData =  async (project: Project) => {
        // const response: Scenario = await fetchScenario(scenario!!.id)
        // setCurrentScenario(response);
    }


    const handleUploadProject = async (file: File) => {
        if (!currentProject) {
            console.error('No presentation selected');
            return;
        }

        setIsUploadModalOpen(true);
        try {
            const response = await uploadProjectVideo(currentProject.id, file, (progress) => {
                setUploadProgress(progress);
                if (progress == 100){
                    setProgressText("Идет распаковка и оптимизация")
                }
            });
            fetchProject(Number(id)).then(setCurrentProject);
        } catch (error) {
            console.error('Error uploading presentation:', error);
            // Handle error (e.g., show an error message to the user)
        } finally {
            setProgressText("Пожалуйста, дождитесь завершения загрузки")
            setIsUploadModalOpen(false);
            setUploadProgress(0);
        }
    };



    return (
        <Box>
            <AppBar className={loading ? 'headerBlock preloading' : 'headerBlock'} position="static">
                <Toolbar className='toolbar'>
                    <Box className='toolbarTitle'>
                        {currentProject ?
                            <Box>{currentProject.title}</Box>
                            :
                            <Box>Проекты <span>{projects.length}</span></Box>
                        }
                    </Box>
                    <Button className="addToobarBtn" variant="contained" onClick={() => {}}><Add /></Button>
                    <HeaderAvatar/>
                </Toolbar>
            </AppBar>


            {!currentProject ? (
                <Box>
                    <Box className='topButtonsContainer hideMPageButtons'>
                        <Box></Box>
                        <Button className='topButtonsAdd' variant="outlined" onClick={() => setIsCreateModalOpen(true)}><Add /> Добавить проект</Button>
                    </Box>
                    {!loading && (

                        <Box className='scenarioList'>
                            {projects.map((item) => (
                                <Box className='scenarioItem' key={item.id} sx={{ display: 'flex', alignItems: 'center', mt: 2 }} onClick={() => handleProjectClick(item)}>
                                    <Box sx={{ flexGrow: 1 }} className='scenarioItemTitle'>{item.title}</Box>
                                </Box>
                            ))}
                        </Box>
                    )}
                </Box>
            ) : (
                <ProjectEditor
                    project={currentProject}
                    onUpload={handleUploadProject}
                    updateProjectData={updateProjectData}
                />
            )}

            {/* Модальное окно добавления */}
            <Modal open={isCreateModalOpen} onClose={() => setIsCreateModalOpen(false)}>
                <Box sx={{flexGrow:1, minHeight: '100vh', display: 'flex', justifyContent:'center', alignItems:'center'}}>
                    <Box className="modalFiled" sx={{ position: 'relative', bgcolor: 'background.paper', boxShadow: 24, maxWidth: 600 }}>
                        <Typography variant="h6">Создание проекта</Typography>
                        <TextField
                            label="Название"
                            value={createName}
                            onChange={(e) => setCreateName(e.target.value)}
                            fullWidth
                            type="text"
                            margin="normal"
                        />
                        <FormControl fullWidth sx={{ mb: 2, mt: 2 }}>
                            <InputLabel id="project-select-label">Выберите сценарий</InputLabel>
                            <Select
                                labelId="project-select-label"
                                id="project-select"
                                value={createScenarioId}
                                label="Выберите сценарий"
                                onChange={(e) => {setCreateScenarioId(e.target.value); fetchVisitsData(e.target.value)}}
                            >
                                {scenarios.map((scenario) => (
                                    <MenuItem key={scenario.id} value={scenario.id}>
                                        {scenario.title}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        {createScenarioId != null && (
                            <FormControl fullWidth sx={{ mb: 2, mt: 2 }}>
                                <InputLabel id="project-select-label">Выберите визит</InputLabel>
                                <Select
                                    labelId="project-select-label"
                                    id="project-select"
                                    value={createVisitId}
                                    label="Выберите визит"
                                    onChange={(e) => setCreateVisitId(e.target.value)}
                                >
                                    {visits.map((visit) => (
                                        <MenuItem key={visit.id} value={visit.id}>
                                            {visit.title}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        )}
                        <Box sx={{display:'flex', justifyContent: 'space-between', mt: 2, gap: 2}}>
                            <Button className="blueModalButton" variant="contained" onClick={handleCreate}>
                                Создать
                            </Button>
                            <Button className="blueModalButton" variant="outlined" onClick={()=>setIsCreateModalOpen(false)} style={{color: 'red', borderColor: 'red'}}>
                                Отмена
                            </Button>
                        </Box>
                    </Box>
                </Box>
            </Modal>

            {/* Модальное окно загрузки */}
            <Modal open={isUploadModalOpen} onClose={() => setIsUploadModalOpen(false)}>
                <Box sx={{flexGrow:1, minHeight: '100vh', display: 'flex', justifyContent:'center', alignItems:'center'}}>
                    <Box className="modalFiled" sx={{ position: 'relative', bgcolor: 'background.paper', boxShadow: 24, maxWidth: 600 }}>
                        <Box sx={{ /* стили */ }}>
                            <Typography sx={{mb: 3}}>{progressText}</Typography>
                            {uploadProgress === 100 ?
                                <Box sx={{display: 'flex', justifyContent: 'center'}}>
                                    <CircularProgress style={{color: '#3a485b'}}/>
                                </Box>
                                :
                                <Box>
                                    <LinearProgress variant="determinate" value={uploadProgress}/>
                                    <Typography>{uploadProgress}%</Typography>
                                </Box>
                            }
                        </Box>
                    </Box>
                </Box>
            </Modal>


        </Box>
    );
};

export default Projects;
